import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import middleware from 'middleware';
import { useEffect } from 'react';
import {
  useGetSectionTemplate,
  useGetSectionTemplateLightList,
} from 'services/templates/section-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { addItem, getExtremeId } from 'utils/dnd/dndUtilities';

const ContractSideMenuSectionsList = () => {
  const { values, setFieldValue, namePrefix, setErrors } = useFormikContractHelpers();

  const sectionTemplateList = useGetSectionTemplateLightList();

  const selectedId = values.sideMenu?.customTemplate?.selectedId;

  const parentId = values.sideMenu?.customTemplate?.parentId;

  const sectionTemplate = useGetSectionTemplate(
    selectedId ?? '',
    {
      notFoundPath: undefined,
      notFoundToastError: i18next.t('toast-message.not-found'),
    },
    !!selectedId,
    false
  );

  useEffect(() => {
    if (!!selectedId && sectionTemplate.data && parentId) {
      const contractTemplateForm = middleware.template.section.queryToForm(
        sectionTemplate.data,
        `${parseInt(getExtremeId(values.items)) + 1}`
      );

      const section = contractTemplateForm[0].children[0];

      if (contractTemplateForm) {
        setFieldValue(namePrefix, addItem(values.items, parentId, section));
        setFieldValue('sideMenu.customTemplate.selectedId', undefined);
        setErrors({})
      }
      console.log(
        'useEffect - sectionTemplate',
        selectedId,
        sectionTemplate.data
      );
    }
  }, [selectedId, sectionTemplate.data]);

  return (
    <Contract.SideMenu.TemplatesList.Wrapper
      templates={sectionTemplateList.data}
      templateType={TEMPLATE_TYPE.section}
      item={template => (
        <Contract.SideMenu.TemplatesList.ListItem
          key={template.id}
          template={template}
        />
      )}
    />
  );
};

export default ContractSideMenuSectionsList;
